import { ca } from '@cian/analytics';

export function trackShowEmptyScreen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'show_empty_view',
  });
}

export function trackSignInButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click',
    label: 'empty_go_to_lk',
  });
}

export function trackSearchOffersButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click',
    label: 'empty_go_to_search',
  });
}
